import { render, staticRenderFns } from "./PxQuestionSection.vue?vue&type=template&id=53b0603a&scoped=true"
import script from "./PxQuestionSection.vue?vue&type=script&lang=js"
export * from "./PxQuestionSection.vue?vue&type=script&lang=js"
import style0 from "./PxQuestionSection.vue?vue&type=style&index=0&id=53b0603a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b0603a",
  null
  
)

export default component.exports